export const GOOGLE_CLIENT_ID: string = "1033262100860-8nk4pe4gha47oem000rj7m5nq2cpmrua.apps.googleusercontent.com";

export const GOOGLE_SECRET: string = "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";
